import { render, staticRenderFns } from "./sidebar-top.vue?vue&type=template&id=0b7e2538&"
import script from "./sidebar-top.vue?vue&type=script&lang=js&"
export * from "./sidebar-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e2538')) {
      api.createRecord('0b7e2538', component.options)
    } else {
      api.reload('0b7e2538', component.options)
    }
    module.hot.accept("./sidebar-top.vue?vue&type=template&id=0b7e2538&", function () {
      api.rerender('0b7e2538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/sidebar-top.vue"
export default component.exports